// colonna trasporto e gestione contatore

class Trasporto {
    
    zone = [
        {
            scaglioni: [        // Valle d'Aosta, Piemonte, Liguria
                0.056176, 0.135614, 0.128884, 0.12919, 0.110733, 0.083811
            ],
            fisso: 67.95
        },
        {
            scaglioni: [        // Lombardia, Trentino-Alto Adige, Veneto, Friuli-Venezia Giulia, Emilia-Romagna
                0.056176, 0.116337, 0.111240, 0.111472, 0.097493, 0.077105
            ],
            fisso: 58.47
        },
        {
            scaglioni: [        // Toscana, Umbria, Marche
                0.056176, 0.139367, 0.132319, 0.132639, 0.11331, 0.085117
            ],
            fisso: 62.85
        },
        {
            scaglioni: [        // Abruzzo, Molise, Puglia, Basilicata
                0.056176, 0.159616, 0.150853, 0.151251, 0.127217, 0.092161
            ],
            fisso: 58.77
        },
        {
            scaglioni: [        // Lazio, Campania
                0.056176, 0.199753, 0.187588, 0.188141, 0.154781, 0.106124
            ],
            fisso: 75.16
        },
        {
            scaglioni: [        // Calabria, Sicilia
                0.056176, 0.250933, 0.234432, 0.235182, 0.189931, 0.123928
            ],
            fisso: 85.10
        }
    ]

    getCluster( regione ){
        let zona = this.zone[0];
        switch (regione) {
            case 'Lombardia':
            case 'Trentino-Alto Adige':
            case 'Veneto':
            case 'Friuli-Venezia Giulia':
            case 'Emilia-Romagna':
                zona = this.zone[1];
            break;
            case 'Toscana':
            case 'Umbria':
            case 'Marche':
                zona = this.zone[2];
            break;
            case 'Abruzzo':
            case 'Molise':
            case 'Puglia':
            case 'Basilicata':
                zona = this.zone[3];
            break;
            case 'Lazio':
            case 'Campania':
                zona = this.zone[4];
            break;
            case 'Calabria':
            case 'Sicilia':
                zona = this.zone[5];
            break;
            case "Val d'Aosta":
            case "Piemonte":
            case "Liguria":
            default:
                // do nothing we are already in the right zone
                break;
        }

        return zona;
    }

}
export default new Trasporto();